import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M 6 2 C 3.7840006 2 2 3.7840252 2 6 L 2 18 C 2 20.216013 3.7840006 22 6 22 L 18 22 C 20.216 22 22 20.216013 22 18 L 22 6 C 22 3.7840252 20.216 2 18 2 L 6 2 z M 6.5 11 L 17.5 11 C 18.05 11 18.5 11.450003 18.5 12 C 18.5 12.550035 18.05 13 17.5 13 L 6.5 13 C 5.9500001 13 5.5 12.550035 5.5 12 C 5.5 11.450003 5.9500001 11 6.5 11 z" />,
  'IndeterminateCheckbox'
);
